import BaseModel from '../BaseModel';

enum NotificationType {
  Plain_Text = 'plain_text',
  Endpoint = 'endpoint',
  Url = 'url',
}

enum NotificationPolicyType {
  Annual_Policy_Expiring_Soon = 'annual_policy_expiring_soon',
  Contract_policy_expiring_soon = 'contract_policy_expiring_soon',
}

export interface NotificationModelProps {
  id: string;
  read: boolean | null;
  created_at: string;
  context: {
    title: string;
    detail: string;
    type: string;
    business_type: string;
    key: string;
  };
  level: 'info' | 'warning' | 'error';
  canRenew?: boolean;
  canExtend?: boolean;
  canJumpUrl?: boolean;
}

class NotificationModel extends BaseModel implements NotificationModelProps {
  id: string;
  read: boolean;
  created_at: string;
  level: 'info' | 'warning' | 'error';
  context: { title: string; detail: string; type: string; business_type: string; key: string };
  canRenew?: boolean;
  canExtend?: boolean;
  canJumpUrl?: boolean;

  transformServeDataToInstance(data: any): void {
    super.transformServeDataToInstance(data);

    this.canRenew = this.context?.type === NotificationType.Endpoint && this.context?.business_type === NotificationPolicyType.Annual_Policy_Expiring_Soon;
    this.canExtend = this.context?.type === NotificationType.Endpoint && this.context?.business_type === NotificationPolicyType.Contract_policy_expiring_soon;
    this.canJumpUrl = this.context?.type === NotificationType.Url;
  }
}

export default NotificationModel;
